<template>
  <div class="lad-filter--language-content">
    <slot name="before-range" />

    <div class="wrapper-element-filter">
      <el-checkbox-group v-model="privateValues">
        <el-checkbox v-for="item in items" :key="item" :label="item">{{
          $t(`${base}.language.options.${item}`)
        }}</el-checkbox>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LadFilterLanguage',
  props: {
    // eslint-disable-next-line vue/require-valid-default-prop
    values: { type: Array, default: [], required: true },
  },
  data() {
    return {
      base: 'filters',
      privateValues: [],
      items: ['es', 'en', 'other'],
    }
  },
  watch: {
    values: {
      immediate: true,
      handler(newValue, oldValue) {
        this.privateValues = newValue
      },
    },
    privateValues(newValue, oldValue) {
      if (typeof oldValue !== 'undefined') {
        this.$emit('update-values', newValue)
      }
    },
  },
}
</script>

<style lang="scss">
.lad-filter--language-content {
  width: auto;

  .el-checkbox {
    margin-right: 0;
    text-transform: capitalize;
    line-height: 1.8;
  }
}
</style>
